import { frontendURL } from 'dashboard/helper/URLHelper.js';

import ScheduledMessagesRouteView from './pages/ScheduledMessagesRouteView.vue';
import ScheduledMessagesPage from './pages/ScheduledMessagesPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const scheduledMessagesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/scheduled-messages'),
      component: ScheduledMessagesRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'scheduled_messages_index', params: to.params };
          },
        },
        {
          path: 'agendamentos',
          name: 'scheduled_messages_index',
          meta,
          component: ScheduledMessagesPage,
        },
      ],
    },
  ],
};

export default scheduledMessagesRoutes;
